import { render, staticRenderFns } from "./PDFViewerToolbar.vue?vue&type=template&id=58f21bd4&scoped=true&lang=pug"
import script from "./PDFViewerToolbar.vue?vue&type=script&lang=ts"
export * from "./PDFViewerToolbar.vue?vue&type=script&lang=ts"
import style0 from "./PDFViewerToolbar.vue?vue&type=style&index=0&id=58f21bd4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f21bd4",
  null
  
)

export default component.exports